import { render } from "./LearningObjectRearrangementOverlay.vue?vue&type=template&id=cd0bd0d6"
import script from "./LearningObjectRearrangementOverlay.vue?vue&type=script&lang=js"
export * from "./LearningObjectRearrangementOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__